import { ReactNode } from 'react';

export const ContentStateWrapper = ({ id, children }: { id: string; children: ReactNode }) => (
  <div data-testid={id} className="xs:h-[450px] sm:h-[550px]">
    {children}
  </div>
);
